import React from 'react';

import Text from '~/components/core/TextComponents/Text';

import ProgressDuration from './ProgressDuration';
import type { ProgressStatus } from './types';

// Stands in until the run has said anything of its own.
const DEFAULT_PENDING_TEXT = 'Processing...';

/**
 * The run's own words for what it is doing, or why it stopped, with how long it has been at it.
 *
 * Sits above the checklist because a failure's reason is the whole point of looking — inside the
 * failed row it would be a click away. The duration is pushed to the far end so it holds still while
 * the message beside it changes length.
 */
export const ProgressStatusLine: React.FC<{ status?: ProgressStatus; pendingText?: string }> = ({
  status,
  pendingText = DEFAULT_PENDING_TEXT,
}) => (
  <div className="flex items-baseline justify-between gap-8">
    <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} className="min-w-0 text-blue-600">
      {status?.text ?? pendingText}
    </Text>
    {status ? <ProgressDuration status={status} /> : null}
  </div>
);

export default ProgressStatusLine;
